export default {
  'modelscope.cli.tab': '快速使用'
};
